export default "__VITE_ASSET__1BgFA_ns__"